<template>
  <div class="my-groups-update">
    <v-form class="my-groups-form"
            ref="form"
            lazy-validation
            @submit.prevent="submitForm">
      <v-layout flex wrap class="tabs">
        <div class="form-group">
          <v-text-field
            required
            color="primary"
            name="group-name"
            aria-label="group-name"
            v-model="groupName"
            :rules="requiredRule"
          />
          <v-btn class="submit-button"
                 type="submit"
                 :loading="updateLoading"
                 :disabled="name === '' || createLoading"
                 color="primary">
            {{ $t('update') }}
          </v-btn>
        </div>
        <v-btn outline
               class="cancel-button"
               type="button"
               @click="!stopPropagation && closeForm()"
               @click.stop="() => stopPropagation && closeForm()"
               :disabled="updateLoading">
          {{ $t('cancel') }}
        </v-btn>
      </v-layout>
    </v-form>
  </div>
</template>

<script>

import { mapActions, mapState } from 'vuex'
import { GET_GROUPS_LIST, UPDATE_GROUP } from '../../../store/action-types'

export default {
  name: 'MyGroupUpdate',
  props: {
    groups: {
      required: true,
      type: Array
    },
    selectedItem: {
      required: true,
      default: null
    },
    stopPropagation: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      name: '',
      requiredRule: [
        v => !!v.trim() || this.$t('field_required'),
        v => (v && !this.nameExists(v)) || this.$t('name_must_be_unique'),
        v => (v && v.length < 251) || this.$t('field_maximum_characters')
      ]
    }
  },
  computed: {
    ...mapState({
      createLoading: state => state.groups.createLoading,
      updateLoading: state => state.groups.updateLoading
    }),
    groupName: {
      get () {
        return this.selectedItem ? this.selectedItem.name : this.name
      },
      set (value) {
        if ((value) && value.length > 0) {
          this.name = value
        }
      }
    }
  },
  methods: {
    ...mapActions({
      getGroupsList: GET_GROUPS_LIST
    }),
    closeForm () {
      this.$emit('edit-form:close', null)
      this.name = ''
    },
    nameExists (value) {
      const filtered = this.groups.filter(el => el.id !== this.selectedItem.id)
      return filtered.map(el => el.name).includes(value)
    },
    submitForm () {
      if (this.$refs.form.validate()) {
        const groupName = this.name === '' ? this.selectedItem.name : this.name
        const data = {
          groupId: this.selectedItem.id,
          request: {
            name: groupName.trim()
          }
        }
        this.$store.dispatch(UPDATE_GROUP, data).then(() => {
          this.name = ''
          this.$refs.form.reset()
          this.closeForm()
          this.getGroupsList()
        })
      }
    }
  }
}
</script>

<style scoped>
  .my-groups-update {
    padding: 0 35px 0 40px;
  }
  @media (max-width: 600px) {
    .my-groups-update {
      padding: 20px 25px 0 30px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/student/group/MyGroupUpdate.vue